<template>
    <el-button-group>
        <el-button v-if="this.radio === '尚未下单'" style="background: #e6f1fc;color: #1989FA"
                   @click.stop="onClick1">尚未下单
        </el-button>
        <el-button v-else-if="this.radio !== '尚未下单'" style="background: white"
                   @click.stop="onClick1">尚未下单
        </el-button>
        <el-button v-if="this.radio === '进行中的工单'" style="background: #e6f1fc;color: #1989FA"
                   @click.stop="onClick2">进行中的工单
        </el-button>
        <el-button v-else-if="this.radio !== '进行中的工单'" style="background: white"
                   @click.stop="onClick2">进行中的工单
        </el-button>
        <el-button v-if="this.radio === '所有工单'" style="background: #e6f1fc;color: #1989FA"
                   @click.stop="onClick3">所有工单
        </el-button>
        <el-button v-else-if="this.radio !== '所有工单'" style="background: white"
                   @click.stop="onClick3">所有工单
        </el-button>
    </el-button-group>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {

        },
        components: {},
        data() {
            return {
                listServiceSheet : {},
                radio : '尚未下单'
            }
        },
        computed: {},
        created() {

            this.radio = this.$store.getters.getRadio.radio
        },
        methods: {


            onClick1() {
                if (this.radio !== '尚未下单') {
                    this.radio = '尚未下单'
                    this.$store.commit('setRadio', {'radio' : this.radio})
                    this.$emit('changeRadio', this.radio)
                }
            },
            onClick2() {
                if (this.radio !== '进行中的工单') {
                    this.radio = '进行中的工单'
                    this.$store.commit('setRadio', {'radio' : this.radio})
                    this.$emit('changeRadio', this.radio)
                }
            },
            onClick3() {
                if (this.radio !== '所有工单') {
                    this.radio = '所有工单'
                    this.$store.commit('setRadio', {'radio' : this.radio})
                    this.$emit('changeRadio', this.radio)
                }
            },

        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';
</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/segment/listSegment.vue